import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import FormikControl from "../../common/FormikControl";
import { LoadingButton } from "@mui/lab";
import BsModal from "../../common/BaseModal";
import { rejectedUCCoaForm } from "../../../slices/carTForm";

const initialValues = {
    comment: "",
};
const validationSchema = Yup.object().shape({
    comment: Yup.string().required("Reason is required")
});


const RejectCoaForm = ({ open, coaFormId, setOpen, fetchPatientInfo, updateTimeLine, patient_id, feasibility_assessment_id, product_manufacturing_id, qr_code_generated_id }) => {
    const dispatch = useDispatch();
    const handleSubmit = async (values) => {
        try {
            const data = {
                patient_id: patient_id,
                feasibility_assesment_id: feasibility_assessment_id,
                product_manufacturing_id: product_manufacturing_id,
                qr_code_generated_id: qr_code_generated_id,
                comment: values?.comment
            }
            const res = await dispatch(rejectedUCCoaForm({ id: coaFormId, data }))
            if (rejectedUCCoaForm?.fulfilled.match(res)) {
                await updateTimeLine()
                await fetchPatientInfo()
            }
        } catch (err) {
            console.error(err);
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
    });

    const formOptions = [
        {
            label: "Reason",
            type: "textarea",
            name: "comment",
            required: true,
            placeholder: "Enter comment",
        }
    ];


    return (

        <BsModal
            fullWidth={true}
            open={open}
            onClose={() => setOpen(false)}
            title={"Reject COA Form"}
        >
            <Box>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="mb-3">
                        {formOptions.map((props, key) => (
                            <Grid key={key} item xs={12}>
                                <FormikControl formik={formik} {...props} />
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <LoadingButton fullWidth type="submit" variant="contained">
                                Submit
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </BsModal>
    );
};

export default RejectCoaForm;
